import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';

import { from, Observable, of, throwError } from 'rxjs';
import { withLatestFrom, switchMap, catchError } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { AuthService } from './auth.service';
import { Domain } from 'modules/shared/models/domain.models';

import * as AuthActions from 'store/actions/auth.actions';
import { Selectors, AppState } from 'store/root-reducer';

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {

  constructor(public auth: AuthService,
              private store: Store<AppState>) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.auth.getSession())
      .pipe(
        withLatestFrom(this.store.select(Selectors.domain.getCurrentDomain)),
        switchMap(([session, domain]: [any, Domain]) => {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${session.accessToken.jwtToken}`,
              'X-ARTEMIS-DOMAIN': domain ? String(domain.id) : ''
            }
          });
          return next.handle(request);
        }),
        catchError((err: any) => {
          if (err === 'NotAuthenticated' || (err.error && err.error.detail === 'The token provided is invalid')) {
            this.store.dispatch(new AuthActions.LogOut({ isSessionTimeOut: false }));
            return of(err);
          } else {
            return throwError(err);
          }
        })
      );
  }
}
